module.exports = __webpack_public_path__ + "img/finish-carbon.b09bf9a7.jpg";